<template>
  <div class="login">
      <theme></theme>
      <div class="bgimg">
        <img  class="inner_img" src="@/assets/login/login-background.png" alt="">
      </div>
      <div class="interface">
          <div class="login_body">
            <div class="login_title">
                <h1>{{TEXT.Text1}}</h1>
            </div>
            <div class="login_input login_input_account">
                <h1>{{TEXT.Text2}}</h1>
                <input class="login_inputbox el-input__inner" v-model="user.acccount" type="text" placeholder="    请输入账号">
            </div>
            <div class="login_input login_input_password">
                <h1>{{TEXT.Text3}}</h1>
                <input type="text" class="login_inputbox el-input__inner" v-model="user.password" placeholder="    请输入密码">
            </div>
            <div class="login_input login_retrieve_password">
                <h1>{{TEXT.Text4}}</h1>
            </div>
            <div @click="login" class="login_submit">
                <p v-if="loading" class="el-icon-loading"></p>
                <p>登录</p>
            </div>
          </div>
         
      </div>
  </div>
</template>

<script>
import css from '@/css/login.css';
import theme from '../../components/theme'
import axios from 'axios';
import API from '@/api/login'
export default {
  name: 'login-in',
  components:{
    theme
  },
  data(){
    return{
        TEXT:{
          Text1:'登录',
          Text2:'账号',
          Text3:'密码',
          Text4:'找回密码',
          Text5:'',
        },
        user:{
          acccount:'',
          password:'',
        },
        loading:false
      }
  },
  methods:{
     convertTimestampToFormattedDate(timestamp) {
        const date = new Date(timestamp);
        const options = {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          timeZoneName: 'short'
        };

          options.hour24 = true;
        

        return date.toLocaleString('zh-CN', options);
      },
      login(){
        let param = {
          'action' : 'login',
          'customer_id' : this.user.acccount,
          'customer_password' : this.user.password,
          'customer_name' : 'admin'
        }
        this.loading = true;
        // console.log(this.$axios);
        //this.$qs.stringify(param)
        let obj = {
                    "boat": null,
                    "axis": null,
                    "user": {
                        "customer_name": "admin",
                        "customer_password": "admin",
                        "customer_id": "host5",
                        "tempToken": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJqdGkiOiJob3N0NSIsImV4cCI6MTcwODQ5ODA3Mywic3ViIjoiYWRtaW4iLCJpYXQiOjE3MDg0ODM2NzN9.0srHBVbmaaC6IWH2ooN2t9vF3GzX5rkvndGgRFALc2I"
                    },
                    "gps": null,
                    "engineeringProject": null
            }
            localStorage.setItem("token",obj.user.tempToken);
          API.login(param).then(res=>{
            localStorage.setItem("token",res.message.obj);
            
            if(res.message.code == "failed"){
              this.loading = false;
              this.$message({
                            type: 'warning',
                            message: `${res.message.info}`
                        });
            };
            if(res.message.code == "success"){
              this.loading = false;
              this.$message({
                            type: 'success',
                            message: `${res.message.info}`
                        });
              this.$router.push({
                path: '/home',
            })
            }
        }).catch(err=>{
          this.$message({
                            type: 'error',
                            message: '服务器异常,请联系管理员'
                        });
                        this.loading = false;
          console.log(err);
        })
          }
 
     
  },
  mounted(){
      //const formattedDate = this.convertTimestampToFormattedDate(this.time.time +this.time.timezoneOffset);
      //console.log(formattedDate);  
  }
}
</script>

<style scoped>



</style>
